export default function TerritoryProposalSummary({ totals, loading = false, error = "", applied = false }) {
  const cards = [
    ["current", applied ? "Original territory" : "Current territory", "bg-emerald-500"],
    ["removed", "Homes being removed", "bg-red-500"],
    ["added", "Homes being added", "bg-sky-300"],
    ["proposed", applied ? "Agreed proposal total" : "Proposed territory total", "bg-stone-900"],
  ];
  return (
    <div className="space-y-2" data-testid="proposal-summary" aria-live="polite" aria-busy={loading}>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {cards.map(([key, label, color]) => (
          <div key={key} className="bg-white border border-stone-200 rounded-xl p-4">
            <div className="flex items-center gap-2 text-xs text-stone-600">
              <span className={`inline-block w-4 h-4 rounded-sm shrink-0 ${color}`} />{label}
            </div>
            <div className="font-display text-3xl tabular-nums mt-1" data-testid={`proposal-${key}-count`}>
              {loading || error ? "—" : totals?.[key] ?? 0}
            </div>
          </div>
        ))}
      </div>
      <p className={`text-xs ${error ? "text-red-700" : "text-stone-500"}`}>
        {error || (loading ? "Updating home counts…" : `${totals.current} current − ${totals.removed} removed + ${totals.added} added = ${totals.proposed} proposed homes`)}
      </p>
    </div>
  );
}
